import { ImageIcon } from "lucide-react";
import { useState } from "react";
import { imageAssets, imagePositions } from "../../data/assets";
import type { AssetSlotId } from "../../types/content";

type ImageSlotProps = {
  slot: AssetSlotId;
  alt: string;
  src?: string;
  priority?: boolean;
  className?: string;
  aspect?: "landscape" | "portrait" | "square" | "wide";
};

export function ImageSlot({
  slot,
  alt,
  src,
  priority = false,
  className = "",
  aspect = "landscape",
}: ImageSlotProps) {
  const [failed, setFailed] = useState(false);
  const resolvedSrc = src ?? imageAssets[slot];

  if (resolvedSrc && !failed) {
    return (
      <figure className={`image-slot image-slot--${aspect} ${className}`}>
        <img
          src={resolvedSrc}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          style={{ objectPosition: imagePositions[slot] }}
          onError={() => setFailed(true)}
        />
      </figure>
    );
  }

  return (
    <figure
      className={`image-slot image-slot--${aspect} image-slot--placeholder ${className}`}
      role="img"
      aria-label={`${alt}. Fotografia oficial por adicionar.`}
      data-asset-slot={slot}
    >
      <div className="image-slot__ornament" aria-hidden="true" />
      <ImageIcon aria-hidden="true" size={28} strokeWidth={1.5} />
      <figcaption>
        <strong>{alt}</strong>
        <span>Fotografia oficial por adicionar</span>
        <code>{slot}</code>
      </figcaption>
    </figure>
  );
}
